import { render, staticRenderFns } from "./FeedbackBottomSheet.vue?vue&type=template&id=218e3703&scoped=true"
import script from "./FeedbackBottomSheet.vue?vue&type=script&lang=js"
export * from "./FeedbackBottomSheet.vue?vue&type=script&lang=js"
import style0 from "./FeedbackBottomSheet.vue?vue&type=style&index=0&id=218e3703&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218e3703",
  null
  
)

export default component.exports